<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.materiais.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.configuracaoRastreabilidade.materiais.novo")',
        :exibeBotao='true',
        @btnHeaderClicado='goToCadastroMaterial'
    )
    .bloco-materiais
        .bloco-input
            .bloco-input__icon
                i.el-icon-search
            .bloco-input__input
                input.input-search(
                    v-model='filtro',
                    type='text',
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.materiais.busca")',
                    autocomplete='off',
                    @keyup.enter='buscarMateriais(1)'
                )
        .bloco-listagem-materiais
            h3 {{ $t('mensagens.configuracaoRastreabilidade.materiais.listagem') }}
            el-table(:key="listagemTableKey('materiais', materiais, paginacao.pagina + 1)", :data='materiais')
                el-table-column(
                    prop='codigo',
                    :label='$t("mensagens.configuracaoRastreabilidade.materiais.tabela.codigo")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.codigo || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.configuracaoRastreabilidade.materiais.tabela.nome")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}
                
                el-table-column(
                    prop='tipo',
                    :label='$t("mensagens.configuracaoRastreabilidade.materiais.tabela.tipo")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.tipo || '-' }}
            
                el-table-column(
                    :label='$t("mensagens.comuns.acoes")',
                    align='center',
                    width='90'
                )
                    .template.d-flex.justify-content-center.tabela-material-icone(
                        slot-scope='scope'
                    )
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='visualizar(scope.row)'
                                ) {{ $t('mensagens.comuns.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='editar(scope.row)'
                                ) {{ $t('mensagens.comuns.editar') }}
                template(slot='empty')
                el-empty(
                    :description='$t("mensagens.configuracaoRastreabilidade.materiais.semDados")'
                )
        .bloco-paginacao
            span {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.configuracaoRastreabilidade.materiais.materiais') : $t('mensagens.configuracaoRastreabilidade.materiais.material') }}
            el-pagination(
                background,
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina + 1',
                layout='prev, pager, next',
                :total='paginacao.total',
                @current-change='mudarPagina'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import formatters from '@/utils/formatters';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'ConfiguracaoMaterial',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            materiais: [],
            paginacao: {}
        };
    },
    mounted() {
        this.buscarMateriais(1);
    },
    methods: {
        async buscarMateriais(page) {
            this.pageable.page = page - 1;
            const { data } =
                await ContratoOriginacaoService.buscarMateriaisPorFiltro(
                    { filtro: this.filtro },
                    this.pageable
                );
            this.materiais = data.materiais;
            this.paginacao = data.paginacao;
        },
        formatCpfCnpj(value) {
            if (!value || value.trim() === '') return '-';
            return formatters.numeralStringFormatTocpfCnpj(value);
        },
        mudarPagina(page) {
            this.buscarMateriais(page);
        },
        goToCadastroMaterial() {
            this.$router.push({ name: 'CadastroMaterial' });
        },
        visualizar(material) {
            this.$router.push({
                name: 'DetalhesMaterial',
                params: { id: material.id }
            });
        },
        editar(material) {
            this.$router.push({
                name: 'EditarVisualizarMaterial',
                params: { id: material.id }
            });
        }
    }
};
</script>

<style lang="scss">
.bloco-materiais {
    margin: 20px;
}

.bloco-input {
    display: flex;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    @include default-box-shadow();
}

.bloco-input__icon i {
    color: $primary;
}

.bloco-input__input {
    flex: 1;

    input {
        border: 0 !important;
        outline: 0;
        width: 100%;
    }
}

.bloco-listagem-materiais {
    margin-top: 20px;

    h3 {
        margin-bottom: 5px;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
        @include default-box-shadow();
    }
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}

.tabela-material-icone {
    i {
        font-size: 27px;
    }
}
</style>
